import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { money, when } from "@/lib/rides";
import { TopBar } from "@/components/TopBar";
import { MapView } from "@/components/MapView";
import { Sheet, SheetTabs } from "@/components/Sheet";
import { ActiveRideCard } from "@/components/ActiveRideCard";
import { MessagesButton } from "@/components/RideMessages";
import { MyProfileCard } from "@/components/Profiles";
import { RideHistory } from "@/components/RideHistory";
import { StatusBadge } from "@/components/RideStatus";

function DriveTab({ active }) {
  const { data: rides } = useQuery({ queryKey: ["driverRides"], queryFn: () => api.get("/driver/rides").then((r) => r.data), refetchInterval: 8000 });
  const upcoming = (rides || []).filter((r) => r.id !== active?.id);
  return (
    <div className="space-y-4">
      <MyProfileCard mode="driver" />
      <h1 className="font-display text-2xl font-bold tracking-tight">{active ? "Active ride" : "No active ride"}</h1>
      {active ? <ActiveRideCard ride={active} /> : <p className="rounded-2xl bg-muted p-5 text-sm text-muted-foreground" data-testid="driver-no-active">Rides assigned to you show up here.</p>}
      <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Assigned & upcoming</h2>
      {!upcoming.length && <p className="text-sm text-muted-foreground">Nothing else assigned.</p>}
      {upcoming.map((r) => (
        <div key={r.id} className="rounded-2xl border bg-card p-4" data-testid="driver-upcoming-item">
          <div className="flex items-center justify-between"><StatusBadge status={r.status} /><span className="font-semibold">{money(r.fare)}</span></div>
          <p className="mt-2 truncate text-sm font-semibold">{r.pickup.name} → {r.dropoff.name}</p>
          <p className="text-xs text-muted-foreground">{when(r.scheduled_at)} · {r.rider_name}</p>
          <div className="mt-2"><MessagesButton rideId={r.id} className="h-8 text-xs" /></div>
        </div>
      ))}
    </div>
  );
}

export default function DriverMode() {
  const [tab, setTab] = useState("drive");
  const { data: active } = useQuery({ queryKey: ["driverActive"], queryFn: () => api.get("/driver/active").then((r) => r.data), refetchInterval: 5000 });
  return (
    <div data-testid="driver-home">
      <MapView pickup={active?.pickup} dropoff={active?.dropoff} route={active?.route} />
      <TopBar />
      <Sheet>
        <SheetTabs value={tab} onChange={setTab} tabs={[{ value: "drive", label: "Drive" }, { value: "history", label: "Trips" }]} />
        {tab === "history" ? <RideHistory perspective="driver" /> : <DriveTab active={active} />}
      </Sheet>
    </div>
  );
}
